import { Button, Center, Flex, Spinner } from '@chakra-ui/react'
import React, { SetStateAction, useMemo } from 'react'
import { GrStatusWarning } from 'react-icons/gr'
import ChakraModal from '../ChakraModal'
import ErrorTable from './Components/ErrorTable'
import FixesTable from './Components/FixesTable'
import { ISchema } from './definitions'
import { createCsvFile } from './functions'
import useComponentHook, { useDownloadFile } from './useComponentHook'

type TProps = {
  onOkFn: (processedfile: File) => any
  isVisible: boolean
  setIsVisible: React.Dispatch<SetStateAction<boolean>>
} & Parameters<typeof useComponentHook>[0]

function CsvValidator(props: TProps) {
  const { isVisible, setIsVisible } = props
  const modalProps: any = useMemo(
    () => ({
      closeBtn: false,
      size: 'full',
      isOpen: isVisible,
      onClose: () => setIsVisible(false),
      closeOnOverlayClick: false,
      closeOnEsc: false,
      contentProps: {
        width: '80vw',
        height: '80vh',
      },
      bodyProps: {
        overflowY: 'auto',
      },
      isCentered: true,
    }),
    [isVisible, setIsVisible],
  )
  const { data, isLoading } = useComponentHook(props)

  useDownloadFile(props.file)

  if (isLoading)
    return (
      <ChakraModal {...modalProps}>
        <Center h="100%">
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="gray.700" size="xl" />
        </Center>
      </ChakraModal>
    )

  if (data?.errorState)
    return (
      <ChakraModal
        {...modalProps}
        header={
          <Flex align="center" gap={1}>
            <GrStatusWarning style={{ color: 'red' }} />
            Error
          </Flex>
        }
        footer={
          <>
            <Button onClick={() => setIsVisible(false)} bg="orange">
              Abort
            </Button>
            <Button
              ml={2}
              onClick={() => {
                if (data) {
                  const { columns, dataSource } = data
                  const fixes = dataSource.map((eachRow) => {
                    const obj: Partial<ISchema> = { ...eachRow }
                    delete obj['lineNo']
                    return Object.values(obj)
                  })
                  const file = createCsvFile(columns, fixes)
                  props.onOkFn(file)
                  setIsVisible(false)
                }
              }}
            >
              Continue With Errors
            </Button>
          </>
        }
      >
        <ErrorTable errorState={data.errorState} />
      </ChakraModal>
    )

  return (
    <ChakraModal
      {...modalProps}
      header={'Lead CSV Validator'}
      footer={
        <>
          <Button
            onClick={() => {
              if (data) {
                const { columns, schemaFixes } = data
                const fixes = schemaFixes.map((eachRow) => {
                  const obj: Partial<ISchema> = { ...eachRow }
                  delete obj['lineNo']
                  return Object.values(obj)
                })
                const file = createCsvFile(columns, fixes)
                props.onOkFn(file)
                setIsVisible(false)
              }
            }}
          >
            Proceed
          </Button>
        </>
      }
    >
      {!data || isLoading ? (
        isLoading ? (
          <Spinner />
        ) : (
          'No Data from file'
        )
      ) : (
        <FixesTable
          processedData={{
            columns: data.columns,
            dataSource: data.dataSource,
            schemaFixes: data.schemaFixes,
          }}
        />
      )}
    </ChakraModal>
  )
}

export default CsvValidator
